<template>
  <v-card flat class="rounded-xl overflow-hidden pa-8" v-if="ribbon_can('digikala_managment')">
    <custom-tabs v-model="tabs" :tab-items="tabItems" grow>
      <template v-slot:staticItems>
        <v-tabs-items v-model="tabs">
          <!-- تب ۱: تنظیمات قیمت‌گذاری -->
          <v-tab-item>
            <setting-run-time />
          </v-tab-item>

          <!-- تب ۲: قیمت‌گذاری هوشمند -->
          <v-tab-item>
            <smart-prices-tab />
          </v-tab-item>
        </v-tabs-items>
      </template>
    </custom-tabs>
  </v-card>
</template>

<script>
import SettingRunTime from "./SettingRunTime.vue";
import SmartPricesTab from "./SmartPricesTab.vue";

export default {
  name: "PricingManagement",
  components: {
    SettingRunTime,
    SmartPricesTab,
  },
  data: () => ({
    tabs: 0,
  }),
  computed: {
    tabItems() {
      return [
        { text: "تنظیمات قیمت‌گذاری", value: 0, icon: "tune" },
        { text: "قیمت‌گذاری", value: 1, icon: "robot-outline" },
      ];
    },
  },
};
</script>

<style scoped>
.gap-4 {
  gap: 16px;
}

::v-deep .row-bg-green {
  background-color: #e8f5e9 !important;
}

::v-deep .row-bg-yellow {
  background-color: #fffde7 !important;
}

::v-deep .row-bg-red {
  background-color: #ffebee !important; 
}

::v-deep .row-bg-orange {
  background-color: #fff3e0 !important; 
}

::v-deep .row-bg-green:hover { background-color: #c8e6c9 !important; }
::v-deep .row-bg-yellow:hover { background-color: #fff9c4 !important; }
::v-deep .row-bg-red:hover { background-color: #ffcdd2 !important; }
::v-deep .row-bg-orange:hover { background-color: #ffe0b2 !important; }
.gap-2 { gap: 8px; }
.gap-4 { gap: 16px; }

.product-title {
  font-size: 0.9rem;
  color: #424242;
  line-height: 1.6;
}

.dkp-link {
  text-decoration: none;
  color: #1976d2;
  font-weight: 500;
  border-bottom: 1px dashed #1976d2;
}

.variant-code {
  background: #f0f0f0;
  padding: 2px 6px;
  border-radius: 4px;
  font-family: monospace;
}
</style>
